import * as yup from 'yup';
// import * as yup from '';

export const PasswordValidation = yup.object().shape({
  password: yup.string()
    .required()
    .test('caps', '', (value) => value && /[A-Z]/.test(value))
    .test('num', '', (value) => value && /[0-9]/.test(value))
    .min(8),
    
  password_confirmation: yup.string()
    .required()
    // .test('match', '', (value) => value && this.parent.password === value)
});

export const BusinessRegisteratinValidation = yup.object().shape({
  name: yup.string().required(),
  primary_email: yup.string().required().email(),
  country_id: yup.number().required().positive(),
  category_id: yup.number().required().positive(),
  primary_phone: yup.string()
    .required()
    .min(10)
    .max(14)
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, {
      message: 'Format must be +233249149420 or 0249149420'
    })
});

export const ContactPersonValidation = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  email: yup.string().required().email(),
  phone: yup.string()
    .required()
    .min(10,)
    .max(14)
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, {
      message: 'Format must be +233249149420 or 0249149420'
    })
});


export const LoginValidation = yup.object().shape({
  email: yup.string().required().email(),
  password: yup.string().required()
});


export const EmailValidation = yup.object().shape({
  email: yup.string().required().email()
});